import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const boardKanbanStyleId = 'wb-v2-board-kanban-theme';

/**
 * Token bridge for the board's own kanban chrome.
 *
 * The column header template is projected into `w-kanban` from here, so it is styled by this
 * component's LESS and needs the few `--local-kanban-*` variables redeclared on `board-kanban`.
 */
export const boardKanbanBridgeStyles = {
  'board-kanban': {
    '--local-kanban-text': tokens.color.text.primary,
    '--local-kanban-text-tertiary': tokens.color.text.tertiary,
    '--local-kanban-radius-full': tokens.radius.full,
    '--local-kanban-gap-xs': tokens.spacing.xs,
    '--local-kanban-font-size-sm': tokens.font.size.textSm,
    '--local-kanban-font-weight-medium': tokens.font.weight.medium,
    '--local-kanban-line-height-sm': tokens.lineHeight.textSm,
    // Swatch for a column whose value carries no colour — a stale rule column that matches nothing
    // still gets a dot, because a header missing its swatch reads as a broken column, not a neutral one.
    '--local-board-kanban-swatch-neutral': tokens.color.foreground.quaternary,
  },
  // The board body already supplies the page gutter, so the kanban's own side padding would double it
  // and push the first column out of line with the header text and pager. `w-kanban` declares the
  // token on itself, so the override needs the descendant selector to win.
  'board-kanban w-kanban': {
    '--local-kanban-board-padding-x': '0',
  },
};
